<template>
    <div>
        <b-modal
                id="kyb-confirmation-popup"
                ref="modal"
                title="Confirmation"
                size="md"
                hide-footer
                modal-class="hide-footer"
                :hide-header-close="loading"
                no-close-on-backdrop
                no-close-on-esc
                selected_users="selected_users"
        >
            <b-form
                    @submit.stop.prevent
                    @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <div class="export-radio-section">
                            <div class="export-form-section" v-html="message">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <div class="row">
                        <base-button
                                :class="{
                                    disabled: loading,
                                    'col-4': true,
                                    'mx-2': true,
                                }"
                                :btn-label="confirmText"
                                @click="onSubmit()"
                                btn-type="submit"
                                btn-variant="primary"
                        ></base-button>
                        <base-button
                                v-if="customBtnText"
                                :class="{
                                    disabled: loading,
                                    'col-4': true,
                                    'mx-2': true,
                                }"
                                :btn-label="customBtnText"
                                @click="customBtnFunction()"
                                btn-variant="primary"
                        ></base-button>
                        <base-button
                                class="col-3 mx-2" 
                                :disabled="loading"
                                :btn-label="cancelText"
                                btn-type="reset"
                                btn-variant="link"
                        ></base-button>
                    </div>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    import excelIcon from '@/components/icons/ExcelIcon.vue'
    const manualKyc = new resource(
        'customers/kyc'
    )
    const deleteCust = new resource(
        'customers/delete'
    )
    import resource from '@/api/resource'

    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
        components: {
            excelIcon,
        },
        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            customerId: {
                type: String,
            },
            message: {
                type: String,
            },
            type: {
                type: String
            },
            confirmText: {
                type: String,
                default: 'Yes'
            },
            cancelText: {
                type: String,
                default: 'No'
            },
            
            customBtnText: {
                type: String,
            },
            customBtnFunction: {
                type: Function,
            },

        },
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                exportType: 'xlsx',
                form: {
                    exportType: [
                        {
                            text: 'Export All Customers',
                            value: 'exportCustomerDetailsExcel',
                        },
                    ],
                },
            }
        },

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters([
                'loading',
                'hidePopup',
                'chartsHeadings',
                'dataSegmentId',
                'hasScopes',
            ]),
        },
        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {
            async processKyc()
            {
                console.log('docs----',this.customerId)
                this.$store.commit('setLoading', true)

                let postData = {
                    'customerId':this.customerId
                }
                var { data } =
                    await manualKyc.store(
                        postData
                    )

                if(data)
                {
                    this.$toasted.show(data.message, {
                        duration: 2000,
                        type: ['success'],
                    })

                }
                this.onHidden()
                this.$store.commit('setLoading', false)

                console.log(data)
            },
            async deleteCustomer()
            {
                this.$store.commit('setLoading', true)

                let postData = {
                    'customerId':this.customerId
                }
                var { data } =
                    await deleteCust.store(
                        postData
                    )

                if(data)
                {
                    this.$toasted.show(data.message, {
                        duration: 2000,
                        type: ['success'],
                    })
                    this.$emit('eventname', 'success')

                }
                this.onHidden()
                this.$store.commit('setLoading', false)

                console.log(data)
            },
            async onSubmit()
            {
                
                // if(this.type=='existsCheck')
                // {
                    this.$emit('updateExistsCheck', true);
                    this.$refs.modal.hide()
                    this.$store.commit('setLoading', false)
                // }
            },
            /**
             * Handle when the modal is closed
             *
             * @return {void}
             */
            onHidden() {
                this.$refs.modal.hide()
                if(this.type=='existsCheck')
                {
                    this.$emit('updateExistsCheck', false);
                }
            }, // End of onHidden() method
            /**
             * Export Activity Timeline
             *
             * @return {void}
             */

        },
    }
</script>
